import {Component, HostListener, inject, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {GuessResultMessageService} from "./messaging/guess-result-message.service";
import {ErrorMessageService} from "./messaging/error-message.service";
import {ReportSentMessageService} from "./messaging/report-sent-message.service";
import {StartGameMessageService} from "./messaging/start-game-message.service";
import {ThemeService} from "./shared/service/theme.service";
import {SwUpdate} from "@angular/service-worker";
import {MatSnackBar} from "@angular/material/snack-bar";
import {TranslateService} from "@ngx-translate/core";
import {BackToLobbyMessageService} from "./messaging/back-to-lobby-message.service";
import {BeginningOfRoundMessageService} from "./messaging/beginning-of-round-message.service";
import {RoomStore} from "./store/room.store";

const SUPPORTED_LANGUAGES = ['en', 'de'];

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  private readonly roomStore = inject(RoomStore);

  private wasHidden = false;

  constructor(guessResultMessageService: GuessResultMessageService,
              beginningOfRoundMessageService: BeginningOfRoundMessageService,
              errorMessageService: ErrorMessageService,
              reportSendMessageService: ReportSentMessageService,
              startGameMessageService: StartGameMessageService,
              themeService: ThemeService,
              backToLobbyMessageService: BackToLobbyMessageService,
              private swUpdate: SwUpdate,
              private snack: MatSnackBar,
              private translate: TranslateService) {
    // the message services are injected eagerly so they listen to room messages on every page

    const browserLanguage = navigator.language?.split('-')[0];
    const language = SUPPORTED_LANGUAGES.includes(browserLanguage) ? browserLanguage : 'en';
    translate.use(language);
    document.documentElement.lang = language;
  }

  async ngOnInit() {
    if (!this.swUpdate.isEnabled) {
      return;
    }
    const newVersionAvailable = await this.swUpdate.checkForUpdate();
    if (newVersionAvailable) {
      await this.swUpdate.activateUpdate();
      this.snack.open(this.translate.instant('common.update.available'), this.translate.instant('common.update.refresh'))
        .onAction().subscribe(() => window.location.reload());
    }
  }

  @HostListener('document:visibilitychange')
  visibilitychange() {
    if (document.hidden) {
      this.wasHidden = true;
    } else if (this.wasHidden) {
      this.wasHidden = false;
      this.roomStore.rejoinRoom();
    }
  }
}
